module.exports = __webpack_public_path__ + "img/set.54e4a526.svg";